<template>
  <!-- 判断题 -->
  <div class="question-item">
    <div class="title-box">
      <span class="line-name">选项</span>
      <span class="line-dec">请选择正确或错误（默认正确）</span>
    </div>
    <div class="judge">
      <div>
        <el-radio-group :disabled="readOnly" v-model="checkOption">
          <el-radio
            v-for="item in options"
            @change="changeOption"
            :label="item['exam_questions_options.name']"
            border
            :key="item['exam_questions_options.name']"
          >
            {{ item["exam_questions_options.name"] }}</el-radio
          >
        </el-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DsfJudge",
  props: {
    exam_questions_options: {
      type: Array,
      default() {
        return [];
      },
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    saveStatus: {
      type: Boolean,
      default: false,
    },
    dsOrder: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      checkOption: "正确",
      options: [
        {
          "exam_questions_options.name": "正确",
          "exam_questions_options.ds_order": 0,
          "exam_questions_options.is_right": { text: "是", value: "1" },
          type: "judge",
        },
        {
          "exam_questions_options.name": "错误",
          "exam_questions_options.ds_order": 1,
          "exam_questions_options.is_right": { text: "否", value: "0" },
          type: "judge",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      var isJudge = this.exam_questions_options.some((item) => item["exam_questions_options.name"] == "正确");
      if (isJudge && this.exam_questions_options.length == 2) {
        //判断题选项存在
        this.exam_questions_options.forEach((item, index) => {
          this.$set(this.exam_questions_options[index], "type", "judge");
          if (item["exam_questions_options.is_right"]?.value == "1") {
            this.checkOption = item["exam_questions_options.name"];
          }
        });
      } else {
        if (this.dsOrder >= 0) {
          this.$emit("add-judge", this.options, this.dsOrder);
        } else {
          // this.exam_questions_options = this.options;
          this.$emit("add-judge", this.options);
        }
      }
    });
  },
  methods: {
    changeOption(val) {
      this.exam_questions_options.forEach((item, index) => {
        if (item["exam_questions_options.name"] == val) {
          this.exam_questions_options[index]["exam_questions_options.is_right"] = { text: "是", value: "1" };
        } else {
          this.exam_questions_options[index]["exam_questions_options.is_right"] = { text: "否", value: "0" };
        }
      });
    },
  },
  watch: {
    saveStatus(val) {
      if (val) {
        var checked = this.exam_questions_options.some((item) => item["exam_questions_options.is_right"].value == 1);
        if (!checked) {
          dsf.layer.message("请设置正确答案", false);
          this.$emit("set-savestatus", false);
          this.$emit("set-validatesuc", false);
        } else {
          this.$emit("set-validatesuc", true);
        }
      }
    },
    checkOption(val) {
      this.exam_questions_options.forEach((item, index) => {
        if (item["exam_questions_options.name"] == val) {
          this.exam_questions_options[index]["exam_questions_options.is_right"] = { text: "是", value: "1" };
        } else {
          this.exam_questions_options[index]["exam_questions_options.is_right"] = { text: "否", value: "0" };
        }
      });
      if (this.dsOrder >= 0) {
        var options = this.options;
        options.forEach((item, index) => {
          if (item["exam_questions_options.name"] == val) {
            options[index]["exam_questions_options.is_right"] = { text: "是", value: "1" };
          } else {
            options[index]["exam_questions_options.is_right"] = { text: "否", value: "0" };
          }
        });
        this.$emit("add-judge", options, this.dsOrder);
      }
    },
    exam_questions_options: {
      handler(val) {
        if (val.length < 2) {
          if (this.dsOrder >= 0) {
            this.$emit("add-judge", this.exam_questions_options, this.dsOrder);
          } else {
            this.exam_questions_options = this.options;
          }
        }
      },
      deep: true,
    },
  },
};
</script>

<style></style>
